module.exports = __webpack_public_path__ + "static/media/ic-wifi.ab61a546.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-wifi.svg
// module id = 682
// module chunks = 14